export default {
  REGULAR: 0,
  PRETEST: 1,
  POSTTEST: 2,
  UNJUK_KETERAMPILAN: 3,
  TUGAS_PRAKTIK_MANDIRI: 4
}
